<template>
  <div style="width: 100%" class="mapBox">
    <div id="map_canva"></div>
  </div>
</template>
<script>
import imgOn from "../assets/images/on.png";
import imgOff from "../assets/images/off.png";
import red from "../assets/images/red.png";
export default {
  data() {
    return {
      carOptions: [],
      centerPoint: null,
    };
  },
  props: ["bindCar"],
  created() {
  },
  mounted() {},
  methods: {
    getData() {
      let param = {
        carId: this.bindCar,
      };
      this.$store
        .dispatch("VehicleStatus/GET_SELECTCARLOCATION", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              this.carOptions = res.data.data;
              let lng = res.data.data[0].longitude
              let lat = res.data.data[0].latitude
              this.centerPoint = [lng, lat]
              this.initMap();
            }
          }
        })
        .catch((err) => {});
    },
    initMap() {
      const that = this;
      this.map = new BMapGL.Map("map_canva");
      this.map.setMapStyleV2({
        styleId: "",
      });
      this.map.centerAndZoom(new BMapGL.Point(this.centerPoint[0], this.centerPoint[1]), 12);
      this.map.addControl(
        new BMapGL.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
        })
      );
      this.map.enableScrollWheelZoom(true);
      var imgOnPic = new Image();
      imgOnPic.src = imgOn;
      var imgOffPic = new Image();
      imgOffPic.src = imgOff;
      var redPic = new Image();
      redPic.src = red;
      this.carOptions.map((item, index) => {
        if (item.linkState == 0) {
          var icon = new BMapGL.Icon(imgOffPic, new BMapGL.Size(35, 32), {
            anchor: new BMapGL.Size(10, 30),
          });
          var points = new BMapGL.Point(item.longitude, item.latitude);
        } else {
          var icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(35, 32), {
            anchor: new BMapGL.Size(10, 30),
          });
          var points = new BMapGL.Point(item.longitude, item.latitude);
        }
        var markers = new BMapGL.Marker(points, { icon: icon });
        this.map.addOverlay(markers);
        this.openInfo(markers, points, item);
      });
    },
    openInfo(markers, points, item) {
      console.log(item);
      var opts = {
        width: 250,
        height: 280,
      };
      var infoWindow = new BMapGL.InfoWindow(
                this.$t('common.carId') + ':' + item.carId + "<br />" +
                this.$t('common.manufactureNum') + ':' + item.manufactureNum + "<br />" +
                this.$t('common.terminalId') + ':' + item.terminalId + "<br />" +
                this.$t('common.orgName') + ':' + item.orgName + "<br />" +
                this.$t('common.messageTime') + ':' + item.messageTime + "<br />" +
                this.$t('VehicleManagement.province') + ':' + item.province + "<br />" +
                this.$t('VehicleManagement.city') + ':' + item.city + "<br />" +
                this.$t('VehicleManagement.address') + ':' + item.address + "<br />",
                opts
            );
      markers.addEventListener("click", function () {
        this.map.openInfoWindow(infoWindow, points); 
      });
    },
  },
};
</script>
<style>
#map_canva {
  width: 100%;
  height: 700px;
}
</style>
